import React, { ReactElement } from 'react'
import { CDN_URL } from '@/utils/constants'
import useSWRImmutable from 'swr/immutable'
import { fetcher } from '@/utils/fetcher'
import useExchangeRate from '@/utils/hooks/useExchangeRate'
import formatNumber from '@/utils/format-number'
import Outpoint from '@/utils/outpoint'
import { formatSatsPer } from '@/utils/format-sats'

const Fungible = (props: any): ReactElement<{ className?: string }> => {
	const { escrow, id, outpoint } = props.inscription
	const { data } = useSWRImmutable(`${CDN_URL}/${id}`, fetcher)
	const { exchangeRate } = useExchangeRate()

	const isSpent = outpoint ? Outpoint.decode(outpoint?.outpoint).txid !== id.split('i')[0] : false

	if (data) {
		const body = typeof data === 'object' ? data : JSON.parse(data)
		const amt = typeof body.amt === 'string' ? parseFloat(body.amt) : body.amt
		const value = escrow?.satoshi_price / amt
		const { sats, per } = formatSatsPer(value)
		const usd = ((value / 1e8) * exchangeRate).toFixed(2)

		return (
			<div className={`${props.className} flex flex-col items-center justify-center gap-3 bg-card/50 backdrop-blur-sm h-full w-full rounded-md border border-border/50`}>
				<div className="flex flex-col items-center gap-1">
					<p className={`${isSpent ? 'text-destructive' : 'text-foreground'} text-3xl font-bold tracking-tight`}>
						{formatNumber(amt.toString() || '0')}
					</p>
					<p className="uppercase text-sm font-medium text-muted-foreground">
						{body.tick}
					</p>
				</div>

				{isSpent && (
					<div className="whitespace-nowrap px-2.5 py-0.5 rounded-full bg-destructive/10 text-destructive text-xs font-medium">
						Used Transfer
					</div>
				)}

				{escrow && (
					<div className="flex flex-col items-center gap-1">
						<div className="flex items-center gap-1.5 text-sm">
							<span className="font-medium">{sats}</span>
							<span className="text-muted-foreground">{per}</span>
						</div>
						{usd !== '0.00' && (
							<p className="text-xs text-muted-foreground">
								${usd} USD
							</p>
						)}
					</div>
				)}
			</div>
		)
	}

	return <React.Fragment />
}

export default Fungible
